import React, {useState} from "react";
import GearIcon from "../assets/icons/gear-icon.svg";
import {rootToolsMenuConfig, toolsMenuConfig, wgRootMenuConfig} from "./config/navigationconfig";
import {isAdmin, isRoot} from "../util/userControl"
import DropdownNav from "./DropdownNav"

const getMenuConfig = (userData) => {
  const { tenant, userType, role, tenantConfig } = userData || {};
  const isWatchguard = tenantConfig?.is_watchguard;
  if (isRoot(userType)) {
    if (tenant === "actzero-parent") return rootToolsMenuConfig;
    if (tenant === "actzero") return toolsMenuConfig;
    return isWatchguard ? wgRootMenuConfig : toolsMenuConfig;
  }
  if (isWatchguard && isAdmin(role)) return wgRootMenuConfig;
  return toolsMenuConfig;
};

const ToolsMenu = ({
                     activeDropdown,
                     setActiveDropdown,
                     activeNavItem,
                     setActiveNavItem,
                     handleClickTrack,
                     userData
                   }) => {
  const [toolsMenu] = useState(getMenuConfig(userData));

  return (
    <div className="tools-container">
        <span
          onClick={() => activeDropdown === "tools" ? setActiveDropdown("") : setActiveDropdown("tools")}
          className={"tools-btn " + (activeNavItem === "tools" ? "is-active " : "") +
          (activeDropdown === "tools" ? " active-dropdown" : "")
          }
          onMouseOver={() => setActiveDropdown("tools")}
        >
          <img className="gear-icon" alt="Tools" src={GearIcon}/>
        </span>
      <div
        className="tools-dropdown"
        onMouseLeave={() => setActiveDropdown("")}
      >
        {activeDropdown === "tools" && (
          <DropdownNav
            setActiveDropdown={setActiveDropdown}
            data={toolsMenu}
            indent={45}
            activeNavItem={activeNavItem}
            setActiveNavItem={setActiveNavItem}
            handleClickTrack={handleClickTrack}
            activeDropdown={activeDropdown}
            className="tools-btn"
            disableMDRLiteAndMobile={() => {
            }}
          />
        )}
      </div>
    </div>
  )
}

export default ToolsMenu;
